<div class="col-12 small">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: ''">
    <ol class="breadcrumb my-5 align-items-center">
      <ng-container *ngIf="!hideHome">
        <li class="breadcrumb-item">
          <a href="/" routerLink="/">
            <digital-platform-icon
              icon="home-solid"
              color="primary"
              data-automation-id="icon-home"
              [width]="24"
              [height]="24"
            ></digital-platform-icon>
          </a>
        </li>

        <li class="mx-4" *ngIf="nestedBreadcrumbItem.length > 0">
          <ng-container *ngTemplateOutlet="linkSeparator"></ng-container>
        </li>
      </ng-container>

      <ng-container
        *ngFor="let breadCrumb of nestedBreadcrumbItem; let last = last"
      >
        <li class="breadcrumb-item" aria-current="page">
          <a
            [href]="breadCrumb.linkUrl"
            [routerLink]="breadCrumb.linkUrl"
            data-automation-id="breadcrumb-link"
            *ngIf="isRoutableLink(breadCrumb.linkUrl); else absoluteLink"
            [class.disabled]="last"
            [attr.role]="breadCrumb.linkUrl ? undefined : 'button'"
          >
            {{ breadCrumb.linkTitle }}
          </a>
          <ng-template #absoluteLink>
            <a
              [href]="breadCrumb.linkUrl"
              [routerLink]="breadCrumb.linkUrl"
              data-automation-id="breadcrumb-link"
              [class.disabled]="last"
              [attr.role]="breadCrumb.linkUrl ? undefined : 'button'"
            >
              {{ breadCrumb.linkTitle }}
            </a>
          </ng-template>
        </li>
        <li class="mx-4" *ngIf="!last">
          <ng-container *ngTemplateOutlet="linkSeparator"></ng-container>
        </li>
      </ng-container>
    </ol>
  </nav>
</div>

<ng-template #linkSeparator>
  <digital-platform-icon
    icon="angle-right-solid"
    data-automation-id="breadcrumb-divider"
    color="cool-gray-4c"
    [width]="15"
    [height]="15"
  ></digital-platform-icon>
</ng-template>
